import PropTypes from 'prop-types';
import * as ICON from '../../Icons';
import { CheckedCircleIcon, DangerIcon, InfoIcon, MessageIcon, WarningIcon } from '../../Icons';

const CONTEXT_ICON = {
  chat: MessageIcon,
  danger: DangerIcon,
  info: InfoIcon,
  success: CheckedCircleIcon,
  warning: WarningIcon,
};

/*
#tailwind
*/

function ToastIcon({ icon }) {
  const Icon = CONTEXT_ICON[icon] ?? ICON[icon];
  return Icon ? <Icon /> : icon;
}

ToastIcon.propTypes = {
  icon: PropTypes.node,
};

ToastIcon.defaultProps = {
  icon: undefined,
};

export default ToastIcon;
